import { useTranslations } from '@vocab/react';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { useAnalytics } from 'src/contexts/AnalyticsContext';
import { useTypedSelector } from 'src/reducers';

import translations from './.vocab';
import PreferencesNew from './Preferences';
import { useSetCandidateId } from './hooks/useSetCandidateId';
import { useUserProfile } from './hooks/useUserProfile';
import { PageTitles } from './pageTitle';
import { useSetTrackingContext } from './tracking/tealium';

export const Notifications = () => {
  const brand = useTypedSelector((state) => state.page.pageAnalytics.brand);
  const { t } = useTranslations(translations);
  const { user } = useUserProfile();
  const { trackPageLoad } = useAnalytics();

  useEffect(() => {
    if (user) {
      trackPageLoad({ currentPage: 'notification settings' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]); // Disabling dependency on trackPageLoad to only track initial tab render

  useSetCandidateId();
  useSetTrackingContext();

  return (
    <>
      <Helmet>
        <title>{`${PageTitles[brand]} - ${t('preferences-page-title')}`}</title>
      </Helmet>
      <PreferencesNew />
    </>
  );
};
